module.exports = __webpack_public_path__ + "media/noaction.4916f888.ogg";